<template>
    <div>
        <basic-container>
            <avue-crud :option="tableOption" :data="tableData" :table-loading="tableLoading" :page="page" ref="crud"
                @search-change="searchChange" @refresh-change="refreshChange(page)" @row-save="handleSave"
                @selection-change="handleSelectionChange" @size-change="pageSizeChange" @row-update="handleUpdate"
                @current-change="pageChange">
                <template slot-scope="scope" slot="menuLeft">
                    <el-button size="mini" type="primary" @click="handleAdd" icon="el-icon-plus">
                        新增
                    </el-button>
                    <el-button size="mini" type="danger" @click="handleDel(scope.row)" icon="el-icon-delete">
                        删除
                    </el-button>
                </template>
                <template slot-scope="scope" slot="shopNameForm">
                    <el-select v-model="department" placeholder="请选择店铺" required filterable value-key="id"
                        @change="changeShopId">
                        <el-option v-for="department in departments" :key="department.id" :label="department.shopName"
                            :value="department"></el-option>
                    </el-select>
                </template>

                <template slot-scope="scope" slot="provincesForm">
                    <avue-map v-model="point"></avue-map>
                </template>
                <!-- 详细地址 -->
                <template slot-scope="scope" slot="addressForm">
                    <el-input clearable type="textarea" name="title" v-model="point.address"></el-input>
                </template>
                <!-- 操作按钮 -->
                <template slot-scope="scope" slot="menu">
                    <!-- 查看 -->
                   <!--  <el-button size="mini" type="success" @click="handleView(scope.row)" icon="el-icon-view">
                        查看
                    </el-button> -->
                    <!-- 编辑 -->
                    <!-- <el-button size="mini" type="primary" @click="handleEdit(scope.row, scope.$index)"
                        icon="el-icon-edit">
                        编辑
                    </el-button> -->
                    <!-- 删除 -->
                    <el-button size="mini" type="danger" @click="handleDel(scope.row)" icon="el-icon-delete">
                        删除
                    </el-button>
                </template>
            </avue-crud>
        </basic-container>
    </div>
</template>
<script>
import { decoratorOption } from "@/const/salesCloud/decoratorOption";
import {
    getDecoratorList,
    addOrEditDecorator,
    delDecorator
} from "@/api/salesCloud/decorator";
import { findAllSuperiorDepartment } from "@/api/salesCloud/goodsQr";
export default {
    name: "decorator",
    data() {
        return {
            tableOption: decoratorOption, //表格设置属性
            department: "", //店铺
            departments: [],
            tableData: [], //表格的数据
            tablePage: 1,
            tableLoading: false,
            loading: false,
            dialogFormVisible: false,
            ids: "",
            point: {},
            page: {
                total: 0, //总页数
                currentPage: 1, //当前页数
                pageSize: 10 //每页显示多少条
            },
        };
    },
    created() {
        this.handleList();
    },
    watch: {},
    mounted() { },
    computed: {},
    props: [],
    methods: {
        // 获取店铺列表
        getDepartment() {
            findAllSuperiorDepartment().then((res) => {
                let data = JSON.parse(res.data).rows;
                this.departments = data;
            });
        },
        changeShopId() {
            this.$refs.crud.$refs.tableForm.form.shopName = this.department.shopName;
            this.$refs.crud.$refs.tableForm.form.shopId = this.department.id;
        },
        clean() {
            this.point = {};
            this.department = "";
        },
        pageSizeChange(pageSize) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = this.page.currentPage;
            params.size = pageSize;
            this.downloadData = params;
            getDecoratorList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: pageSize
                };
                this.tableLoading = false;
            });
        },
        pageChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page;
            params.size = this.page.pageSize;
            this.downloadData = params;
            getDecoratorList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
        },
        searchChange(params) {
            this.tableLoading = true;
            params.page = this.page.currentPage;
            params.size = this.page.pageSize;
            getDecoratorList(params).then(res => {
                if (res.code != 500) {
                    let data = JSON.parse(res.data);
                    this.tableData = data.rows;
                    this.page = {
                        total: data.total,
                        currentPage: params.page,
                        pageSize: params.size
                    };
                    this.tableLoading = false;
                } else {
                    this.tableLoading = false;
                    this.tableData = [];
                }
            });
        },
        refreshChange(page) {
            this.tableLoading = true;
            let params = this.$refs.crud.searchForm;
            params.page = page.currentPage;
            params.size = page.pageSize;
            this.downloadData = params;
            getDecoratorList(params).then(res => {
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                this.page = {
                    total: data.total,
                    currentPage: page.currentPage,
                    pageSize: page.pageSize
                };
                this.tableLoading = false;
            });
        },
        /**
         * @title 打开新增窗口
         * @detail 调用crud的handleadd方法即可
         *
         **/
        handleAdd() {
            this.clean();
            this.$refs.crud.rowAdd();
        },
        handleSave(form, done, loading) {
            let params = {
                shopId: this.department.id,
            };
            addOrEditDecorator(params).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "新增成功",
                        type: "success"
                    });
                    done();
                    this.handleList();
                } else {
                    setTimeout(() => {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : '新增失败,请重试',
                            type: "error"
                        });
                        loading();
                    }, 1000)

                }
            });
        },
        handleEdit(row, index) {
            this.clean();
            this.$refs.crud.rowEdit(row, index);
            this.department = {
                id: row.shopId,
                shopName: row.shopName
            };
            this.point = {
                address: row.address,
                location: {
                    lng: row.longitude,
                    lat: row.latitude
                }
            };
        },
        handleUpdate(form, index, done, loading) {
            let params = {
                ...form,
                id: form.id,
                shopId: this.department.id,
            };
            const isEdit = true;
            addOrEditDecorator(params, isEdit).then(res => {
                if (res.code == "200") {
                    this.$message({
                        showClose: true,
                        message: "修改成功",
                        type: "success"
                    });
                    done();
                    this.handleList();
                } else {
                    setTimeout(() => {
                        this.$message({
                            showClose: true,
                            message: res.message ? res.message : '编辑失败,请重试',
                            type: "error"
                        });
                        loading();
                    }, 1000)
                }
            });
        },
        handleView(row) {
            this.clean();
            this.$refs.crud.rowView(row);
        },
        handleList() {
            this.tableLoading = true;
            let params = {
                page: this.page.currentPage,
                size: this.page.pageSize
            };
            this.downloadData = params;
            getDecoratorList(params).then(res => {
                console.log(res);
                
                let data = JSON.parse(res.data);
                this.tableData = data.rows;
                console.log(this.tableData);
                
                this.page = {
                    total: data.total,
                    currentPage: this.page.currentPage,
                    pageSize: this.page.pageSize
                };
                this.tableLoading = false;
            });
            this.getDepartment();
        },
        /**
         * @title 当前选中的数据
         * @param val 选中的值
         *
         **/
        handleSelectionChange(val) {
            let ids = val.map(item => {
                return item.id;
            });
            this.ids = ids.join(",");
        },
        /**
         * @title 数据删除
         * @param row 为当前的数据
         * @param index 为当前更新数据的行数
         *
         **/
        handleDel(row) {
            let ids = "";
            ids = this.ids;
            if (row) {
                ids = row.id;
                this.$confirm(`您确定删除该条数据吗？`, "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        delDecorator(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功删除",
                                        type: "success"
                                    });
                                    this.handleList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message ? res.message : '删除失败,请重试',
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            } else {
                if (!ids) {
                    this.$message({
                        showClose: true,
                        message: "未选中任何数据",
                        type: "error"
                    });
                    return;
                }
                let length = ids.split(",").length;
                this.$confirm(
                    `共选中${length}条数据吗，您确定批量删除吗？`,
                    "提示",
                    {
                        confirmButtonText: "确定",
                        cancelButtonText: "取消",
                        type: "warning"
                    }
                )
                    .then(() => {
                        Decorator(ids)
                            .then(res => {
                                if (res.code == "200") {
                                    this.$message({
                                        showClose: true,
                                        message: "成功",
                                        type: "success"
                                    });
                                    this.handleList();
                                } else {
                                    this.$message({
                                        showClose: true,
                                        message: res.message,
                                        type: "error"
                                    });
                                }
                            })
                            .catch(error => {
                                this.loading = false;
                                this.$message({
                                    showClose: true,
                                    message: error,
                                    type: "error"
                                });
                            });
                    })
                    .catch(() => { });
            }
        },
    }
};
</script>

<style lang="scss">
.table-container {
    padding: 8px 10px;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    width: 50%;
}
</style>